"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryDto = void 0;
class QueryDto {
    constructor(queryDto) {
        this.id = parseInt(queryDto.id);
        this.model = queryDto.model;
        this.view = queryDto.view;
        this.fields = queryDto.fields;
        this.filters = queryDto.filters;
        this.filterConfig = queryDto.filterConfig;
        this.filterExpression = queryDto.filterExpression;
        this.slug = queryDto.slug;
    }
    static get QUERY_FIELDS() {
        return `id,model,view,fields,filters,filter_config,filter_expression,slug`;
    }
}
exports.QueryDto = QueryDto;
